<div class="toolbar-wrapper">
  <div
    class="toolbar"
    [class.toolbar--dark]="dark"
    [class.toolbar--contact]="variant === 'contact'">
    <a class="toolbar__logo" routerLink="/" fragment="main">
      <img src="https://images.sitco.ru/main/logo.svg" alt="Sitco">
    </a>

    <button
      class="toolbar__button"
      type="button"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="isMenuOpen()"
      (click)="toggleMenu()">
      <span
        class="toolbar__dots"
        [class.toolbar__dots--open]="isMenuOpen()"
        aria-hidden="true">
        <i></i><i></i><i></i>
        <i></i><i></i><i></i>
        <i></i><i></i><i></i>
      </span>
    </button>
  </div>

  <div
    class="toolbar-menu"
    *ngIf="variant === 'menu'"
    [class.toolbar-menu--open]="isMenuOpen()">

    <div class="toolbar-menu__content">
      <nav class="toolbar-menu__nav">
        <a routerLink="/about" (click)="closeMenu()">About</a>
        <a routerLink="/" fragment="services" (click)="closeMenu()">Services</a>
        <a routerLink="/" fragment="projects" (click)="closeMenu()">Projects</a>
        <a routerLink="/" fragment="contact" (click)="closeMenu()">Contact</a>
      </nav>

      <div class="toolbar-menu__info">
        2026 © SitCo
      </div>
    </div>
  </div>

  <div
    class="toolbar-contact"
    *ngIf="variant === 'contact'"
    [class.toolbar-contact--open]="isMenuOpen()">

    <div class="toolbar-contact__title">
      Ready to start?<br>
      Enter your email
    </div>

    <form class="toolbar-contact__form">
      <input type="email" placeholder="Email">
      <button type="button">Submit</button>
    </form>
  </div>
</div>
